import { Button, Grid, styled, TextField } from "@mui/material";
import { grey, greyLight } from "../../common/Theme/theme";
import loginImage from "../../assets/login-image.svg";

const RESET_PASSWORD_PREFIX = "ResetPassword";

export const resetPasswordClasses = {
    root: `${RESET_PASSWORD_PREFIX}-root`,
    logoContainer: `${RESET_PASSWORD_PREFIX}-logoContainer`,
    logoLight: `${RESET_PASSWORD_PREFIX}-logoLight`,
    logoDark: `${RESET_PASSWORD_PREFIX}-logoDark`,
    leftPanel: `${RESET_PASSWORD_PREFIX}-leftPanel`,
    rightPanel: `${RESET_PASSWORD_PREFIX}-rightPanel`,
    link: `${RESET_PASSWORD_PREFIX}-link`,
    welcome: `${RESET_PASSWORD_PREFIX}-welcome`,
    buttonIcon: `${RESET_PASSWORD_PREFIX}-buttonIcon`,
    heading: `${RESET_PASSWORD_PREFIX}-heading`,
};

export const StyledResetPassword = styled(Grid)(({ theme }) => ({
    [`&.${resetPasswordClasses.root}`]: {},
    [`& .${resetPasswordClasses.leftPanel}`]: {
        [theme.breakpoints.up("md")]: {
            backgroundImage: `url(${loginImage})`,
            width: "100%",
            height: "110vh",
            backgroundSize: "cover",
            backgroundPosition: "bottom",
            backgroundRepeat: "no-repeat",
        },
        [theme.breakpoints.only("sm")]: {
            backgroundImage: `url(${loginImage})`,
            width: "100%",
            height: "50vh",
            backgroundSize: "cover",
            backgroundPosition: "bottom",
            backgroundRepeat: "no-repeat",
        },
    },
    [`& .${resetPasswordClasses.rightPanel}`]: {
        background: "rgba(225, 224, 223, 0.5)",
        [theme.breakpoints.up("sm")]: {
            padding: "30px 160px",
        },
        [theme.breakpoints.only("sm")]: {
            height: "60vh",
        },
        [theme.breakpoints.only("md")]: {
            height: "110vh",
        },
        [theme.breakpoints.down("sm")]: {
            padding: "100px 30px",
            height: "110vh",
        },
    },
    [`& .${resetPasswordClasses.logoContainer}`]: {
        width: "10%",
        [theme.breakpoints.up("sm")]: {
            position: "absolute",
            left: "10%",
            top: "10%",
        },
        [theme.breakpoints.only("sm")]: {
            left: "5%",
            top: "5%",
        },
        [theme.breakpoints.down("sm")]: {
            position: "absolute",
            margin: "20px",
        },
    },
    [`& .${resetPasswordClasses.logoLight}`]: {
        [theme.breakpoints.up("sm")]: {
            display: "block",
        },
        [theme.breakpoints.only("sm")]: {
            display: "block",
        },
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    [`& .${resetPasswordClasses.logoDark}`]: {
        [theme.breakpoints.up("sm")]: {
            display: "none",
        },
        [theme.breakpoints.only("sm")]: {
            display: "none",
        },
        [theme.breakpoints.down("sm")]: {
            display: "block",
        },
    },
    [`& .${resetPasswordClasses.link}`]: {
        textDecoration: "none",
    },
    [`& .${resetPasswordClasses.welcome}`]: {
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        color: greyLight,
        marginBottom: "30px",
    },
    [`& .${resetPasswordClasses.buttonIcon}`]: {
        marginRight: "10px",
    },
    [`& .${resetPasswordClasses.heading}`]: {
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "20px",
        lineHeight: "24px",
        display: "flex",
        alignItems: "center",
    },
}));

export const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.common.white,
    fontFamily: "Rubik",
    borderRadius: "100px",
    height: "40px",
    textTransform: "capitalize",
    marginBottom: "30px",
    width: "fit-content",
}));

export const CssTextField = styled(TextField)(({ theme }) => ({
    color: grey,
    background: "transparent",
    borderColor: greyLight,
    boxSizing: "border-box",
    borderRadius: "8px",
    marginBottom: "40px",
    marginRight: "40px",
    width: "90%",
    "& .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedStart":
        {
            background: theme.palette.common.white,
            border: "1px solid rgba(225, 224, 223, 0.5)",
        },
    "& label.Mui-focused": {
        color: greyLight,
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "rgba(225, 224, 223, 0.5)",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "rgba(225, 224, 223, 0.5)",
        },
        "&:hover fieldset": {
            borderColor: "rgba(225, 224, 223, 0.5)",
        },
        "&.Mui-focused fieldset": {
            borderColor: "rgba(225, 224, 223, 0.5)",
        },
    },
}));
